import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject, signal } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { AuthenticationService } from "@core/services/auth.service";
import { catchError, finalize, switchMap, throwError } from "rxjs";

let refreshInProgress = signal(false);
let refreshCompleted = signal<void | null>(null);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);
  const sendRequest = () => {
    const authReq = req.clone({
      withCredentials: true
    });
    return next(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) authService.resetState();
        return throwError(()=> error)
      }
      )
    );
  };

  if(req.url.includes('/auth')) return sendRequest();

  if (refreshInProgress()) {
    return toObservable(refreshCompleted).pipe(
      switchMap(() => sendRequest())
    );
  }

  if (!sessionAboutToExpire()) {
    return sendRequest();
  }

  refreshInProgress.set(true);
  return authService.getAuthorization$().pipe(
    switchMap(() => {
      return sendRequest();
    }),
    finalize(() => {
      refreshInProgress.set(false);
      refreshCompleted.set(null);
    })
  );
};

function sessionAboutToExpire(): boolean{
  const storageExpTime = localStorage.getItem('sessionExpirationTime')?? 0;
  if(!storageExpTime) return true;
  const expirationTimeInMs = new Date(storageExpTime).getTime();
  const currentTimeInMs = new Date(Date.now()).getTime();
  const tokenExpiryBufferMinutes = 10;
  const tokenExpiryBufferMiliseconds = tokenExpiryBufferMinutes*60*1000;
  return  (expirationTimeInMs - currentTimeInMs) < tokenExpiryBufferMiliseconds;
}
